import Sortable, { MultiDrag } from 'sortablejs'

// 전역 플러그인 마운트 상태 관리
let isMultiDragMounted = false

/**
 * Sortable MultiDrag 플러그인을 안전하게 마운트하는 함수
 * @returns {boolean} 마운트 성공 여부
 */
export const mountMultiDragPlugin = (): boolean => {
  if (isMultiDragMounted) {
    console.warn('MultiDrag plugin is already mounted')
    return true
  }

  try {
    Sortable.mount(new MultiDrag())
    isMultiDragMounted = true
    // console.log('MultiDrag plugin mounted successfully')
    return true
  } catch (error) {
    const err = error as Error
    if (err.message?.includes('Cannot mount plugin multiDrag more than once')) {
      console.warn('MultiDrag plugin already mounted by another instance')
      isMultiDragMounted = true
      return true
    } else {
      console.error('Failed to mount MultiDrag plugin:', err)
      return false
    }
  }
}

/**
 * MultiDrag 플러그인 마운트 상태를 확인하는 함수
 * @returns {boolean} 마운트 상태
 */
export const isMultiDragPluginMounted = (): boolean => {
  return isMultiDragMounted
}

/**
 * Sortable 플러그인 상태를 리셋하는 함수 (주로 테스트용)
 */
export const resetSortablePlugins = (): void => {
  isMultiDragMounted = false
}
